import type { Airflow } from '@aviata/platform-types';

import { BloomreachEventName } from './config';
import { bloomreachLib } from '../bloomreach';
import type { SelectFareFamilyParams } from '../analytics';

const hasRefundableDescription = (
  descriptions: Airflow.FareFamily.Description.Entity[] | null,
): boolean => {
  if (!descriptions || descriptions.length === 0) {
    return false;
  }
  const refundDescription = descriptions.find(d => d.type === 'refund');
  return refundDescription?.state === 'INCLUDE';
};

export const selectFareFamily = (data: SelectFareFamilyParams) => {
  const fareIndex = data.isBaseFare ? 1 : data.choice.id;

  const mappedData = {
    ff_index: fareIndex,
    ff_is_base: data.isBaseFare,
    price: data.choice.price ? Number(data.choice.price.amount) : 0,
    refundable: hasRefundableDescription(data.descriptions),
  };

  bloomreachLib.track(BloomreachEventName.FARE_SELECT, mappedData);
};
